'use client'

import './header-rewards-dropdown-bonus-deposit.scss'

import Countdown from '@/components/design-system/countdown'
import useRewards from '@/hooks/use-rewards'
import CircularCountdown from './header-rewards-dropdown-bonus-deposit-circular-countdown'
import ClaimButton from './header-rewards-dropdown-bonus-deposit-claim-button'

export default function HeaderRewardsDropdownBonusDeposit() {
  const rewards = useRewards()
  const { bonusAmount, resetDepositBonusDate } = rewards.depositBonus ?? {
    bonusAmount: 0,
    resetDepositBonusDate: null,
  }

  if (!bonusAmount || bonusAmount === 0 || resetDepositBonusDate === null)
    return

  return (
    <section className='rewards-dropdown-bonus-deposit'>
      <div className='rewards-dropdown-bonus-deposit__infos'>
        <span className='rewards-dropdown-bonus-deposit__infos__title'>
          BONUS <b>DEPOSIT</b>
        </span>
        <ClaimButton amount={bonusAmount} />
      </div>

      <div className='rewards-dropdown-bonus-deposit__timer-box'>
        <CircularCountdown targetDate={resetDepositBonusDate} />

        <Countdown
          className='rewards-dropdown-bonus-deposit__timer-box__countdown'
          date={resetDepositBonusDate}
        />
      </div>
    </section>
  )
}
